import Vue from "vue"
import VueRouter from "vue-router"
import Dashboard from './components/Dashboard'
import Login from './components/Login'
import OTP from './components/OTP'
import Index from './components/dashboard/Index'

import User from './components/dashboard/User'
import UserCreate from './components/parts/user/UserCreate'
import UserUpdate from './components/parts/user/UserUpdate'


import MessageTemplates from './components/dashboard/MessageTemplates.vue'
import AddMessageTemplates from "./components/parts/messagesTemplate/AddMessageTemplates.vue"
import UpdateMessageTemplates from "./components/parts/messagesTemplate/UpdateMessageTemplates.vue"

import ShablonStatus from './components/dashboard/ShablonStatus.vue'
import UpdateShablonStatus from "./components/parts/shablonStatus/UpdateShablonStatus.vue"

import SmsGroups from "./components/dashboard/SmsGroups"
import AddSmsGroups from "./components/parts/smsGroup/Add.vue"
import UpdateSmsGroups from "./components/parts/smsGroup/Update.vue"

import BulkSMS from "./components/dashboard/BulkSMS"
import AddBulkSMS from "./components/parts/bulkSMS/Add.vue"
import UpdateBulkSMS from "./components/parts/bulkSMS/Update.vue"

import VueMeta from 'vue-meta'
import guest from './middleware/guest'
import auth from './middleware/auth'
import admin from './middleware/admin'
import adminPartner from './middleware/adminPartner'
import store from './store/user'
import middlewarePipeline from './middlewarePipeline'
import ForgotPassword from "./components/ForgotPassword.vue"



import GeneralPartners from "./components/dashboard/GeneralPartners"
import ProcessingPartners from "./components/dashboard/ProcessingPartners"
import ReceivingPartners from "./components/dashboard/ReceivingPartners"
import Report from "./components/dashboard/Report"


Vue.use(VueMeta)
Vue.use(VueRouter)

export const router = new VueRouter({
  routes : [
    {
      path : '/login',
      component : Login,
      name : 'login',
      meta : {
        title : 'Giriş Paneli',
        middleware: [
          guest,
        ]
      }
    },
    {
      path : '/otp/:user',
      component : OTP,
      name : 'otp',
      meta : {
        title : 'Giriş Paneli',
        middleware: [
          guest,
        ]
      }
    },
    {
      path: '/resetPassword',
      component: ForgotPassword,
      name: 'forgotPassword',
      props: true,
      meta: {
        title: 'Parolun dəyişdirilməsi',
        middleware: [
          guest
        ]
      }
    },
    {
      path : '/',
      component : Dashboard,
      children: [
        {
          path: '/',
          component: Index,                    
          name : 'dashboard',
          meta : {
            title : 'PromoBulkCRM',
            middleware: [
              auth,
            ]
          },
        },
        {
          path: '/users',
          component: User,
          name : 'users',
          meta : {
            title : 'İstifadəçilər',
            middleware: [
              auth, 
              admin,
            ]
          },
        },
        {
          path: '/addUser',
          component: UserCreate,
          name : 'addUser',
          meta : {
            title : 'İstifadəçi əlavə etmək',
            middleware: [
              auth, 
              admin
            ]
          },
        },
        {
          path: '/updateUser',
          component: UserUpdate,
          name : 'updateUser',
          meta : {
            title : 'İstifadəçi dəyişmək',
            middleware: [
              auth, 
              admin
            ]
          },
        },
        {
          path: '/bulksms',
          component: BulkSMS,
          name : 'Bulk SMS',
          meta : {
            title : 'Bulk SMS',
            middleware: [
              auth, 
              adminPartner,
            ]
          },
        },
        {
          path: '/bulksms/add',
          component: AddBulkSMS,
          name : 'AddBulkSMS',
          meta : {
            title : 'Add Bulk SMS',
            middleware: [
              auth, 
              adminPartner,
            ]
          },
        },
        {
          path: '/bulksms/update',
          component: UpdateBulkSMS,
          name : 'UpdateBulkSMS',
          meta : {
            title : 'Update BulkSMS',
            middleware: [
              auth, 
              adminPartner,
            ]
          },
        },
        {
          path: '/generalpartners',
          component: GeneralPartners,
          name : 'GeneralPartners',
          meta : {
            title : 'GeneralPartners',
            middleware: [
              auth, 
              admin,
            ]
          },
        },
        {
          path: '/processingpartners',
          component: ProcessingPartners,
          name : 'ProcessingPartners',
          meta : {
            title : 'ProcessingPartners',
            middleware: [
              auth, 
              admin,
            ]
          },
        },
        {
          path: '/ReceivingPartners',
          component: ReceivingPartners,
          name : 'ReceivingPartners',
          meta : {
            title : 'ReceivingPartners',
            middleware: [
              auth, 
              admin,
            ]
          },
        },
        {
          path: '/messageTemplates',
          component: MessageTemplates,
          name : 'MessageTemplates',
          meta : {
            title : 'SMS şablonları',
            middleware: [
              auth, 
              adminPartner,
            ]
          },
        },
        {
          path: '/smsShablonStatus',
          component: ShablonStatus,
          name : 'ShablonStatus',
          meta : {
            title : 'Sms Şablon Status',
            middleware: [
              auth, 
              admin,
            ]
          },
        },
        
        {
          path: '/smsgroups',
          component: SmsGroups,
          name : 'SmsGroups',
          meta : {
            title : 'SMS Group',
            middleware: [
              auth, 
              adminPartner,
            ]
          },
        },

        {
          path: 'smsgroups/add',
          component: AddSmsGroups,
          name : 'AddSmsGroups',
          meta : {
            title : 'SMS Group',
            middleware: [
              auth, 
              adminPartner,
            ]
          },
        },

        {
          path: 'smsgroups/update',
          component: UpdateSmsGroups,
          name : 'UpdateSmsGroups',
          meta : {
            title : 'SMS Group',
            middleware: [
              auth, 
              adminPartner,
            ]
          },
        },

        {
          path: '/addMessageTemplates',
          component: AddMessageTemplates,
          name : 'AddMessageTemplates',
          meta : {
            title : 'Şablon əlavə et',
            middleware: [
              auth, 
              adminPartner,
            ]
          },
        },
        {
          path: '/updateMessageTemplates',
          component: UpdateMessageTemplates,
          name : 'updateMessageTemplates',
          meta : {
            title : 'Şablon dəyiş',
            middleware: [
              auth, 
              adminPartner,
            ]
          },
        },
        {
          path: '/updateShablonStatus',
          component: UpdateShablonStatus,
          name : 'UpdateShablonStatus',
          meta : {
            title : 'Şablon status dəyiş',
            middleware: [
              auth, 
              admin,
            ]
          },
        },
        {
          path: '/Report',
          component: Report,
          name : 'Report',
          meta : {
            title : 'Statistika',
            middleware: [
              auth, 
              adminPartner,
            ]
          },
        },
      ],
    },
    {
      path : '*',
      redirect : '/'
    }
  ],
  mode : "history"
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  if (!to.meta.middleware) {
    return next()
  }
  const middleware = to.meta.middleware

  const context = {
    to,
    from,
    next,
    store
  }
  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  })
})